import React from "react";
import { Checkbox } from "react-materialize";
import $ from "jquery";

export default function CheckboxAction({
  data,
  index,
  actionData,
  setActionData,
}) {
  let action_items = "items" in actionData ? actionData.items : [];
  let actionChecked =
    action_items.indexOf(data.idu) > -1
      ? true
      : false;

  const handleEvents = {
    OnChange: function (evt) {
      const value = parseInt(evt.target.value);
      let items = [...actionData.items];
      if (evt.target.checked) {
        items.push(value);
        items = items.filter((value, index, arr) => index === arr.indexOf(value));
      } else {
        const pos = items.indexOf(value);
        if (pos >= 0) {
            items.splice(pos, 1);
        }
      }
      setActionData({
        ...actionData,
        key: Math.floor(Math.random() * 10000 + 1),
        items: items,
      });
    },
  };

  return (
    <div key="checkbox-action-item" style={{ marginTop: "8px" }}>
      <Checkbox
        key={"action-item-" + index + "-" + actionData.key}
        key-number={actionData.key}
        id={"action-item-" + index}
        checked={actionChecked}
        filledIn
        name="action-item"
        label=""
        // value={data.idu + "-" + data.country_code}
        value={data.idu + ""}
        onChange={handleEvents.OnChange}
      />
    </div>
  );
}
